import { Component, ViewChild, ElementRef } from "@angular/core";
import {
  NavController,
  NavParams,
  LoadingController,
  Loading,
  AlertController,
  ModalController
} from "ionic-angular";
import { Geolocation } from "@ionic-native/geolocation";
import { Http } from "@angular/http";
import "rxjs/add/operator/map";
import * as MarkerClusterer from "node-js-marker-clusterer";
import { ModalDoencas } from "./modal";

declare var google;

@Component({
  selector: "vermapa",
  templateUrl: "vermapa.html"
})
export class VerMapaPage {
  loading: Loading;

  markerCluster: any;
  public markers: any;

  public inserido;

  periodo: string = "todos";
  doencas: string;

  @ViewChild("mapasintomas") mapElement: ElementRef;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public geolocation: Geolocation,
    private http: Http,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    public modalCtrl: ModalController
  ) {
    this.inserido = navParams.get("inserido");

    // if (this.navParams.get('doencas')) {
    // 	this.doencas = this.navParams.get('doencas').toString();
    // }
  }

  ionViewDidLoad() {
    if (this.inserido) {
      document.getElementById("inserido").style.display = "block";
      setTimeout(function() {
        document.getElementById("inserido").style.display = "none";
      }, 3000);
    }

    this.geolocation
      .getCurrentPosition()
      .then(e => {
        this.carregaMapaSintomas("todos");
      })
      .catch(() => {
        this.semGPS();
      });
  }

  semGPS() {
    let alert = this.alertCtrl.create({
      subTitle:
        "Para uma melhor experiência, por favor ative sua localização e reinicie o aplicativo.",
      buttons: [
        {
          text: "OK"
        }
      ]
    });
    alert.present();
  }

  erroGPS(e) {
    let alert = this.alertCtrl.create({
      subTitle:
        "Erro ao detectar sua localização. Por favor reinicie o aplicativo.",
      buttons: [
        {
          text: "OK"
        }
      ]
    });
    alert.present();
    console.log(e);
  }

  showLoading() {
    this.loading = this.loadingCtrl.create({
      content: "Carregando mapa...",
      dismissOnPageChange: true
    });

    this.loading.present();
  }

  abreModalDoencas() {
    let modal = this.modalCtrl.create(ModalDoencas);
    modal.present();

    modal.onDidDismiss(doencas => {
      this.doencas = doencas.toString();
      this.carregaMapaSintomas(this.periodo);
    });
  }

  carregaMapaSintomas(periodo) {
    this.periodo = periodo;

    document.getElementById("48horas").setAttribute("class", "");
    document.getElementById("7dias").setAttribute("class", "");
    document.getElementById("60dias").setAttribute("class", "");
    document.getElementById("todos").setAttribute("class", "");

    document.getElementById(periodo).setAttribute("class", "ativo");

    this.showLoading();

    this.geolocation.getCurrentPosition().then(
      position => {
        let json = `http://maisalguemdoente.com.br/ocorrencias/webService/getOcorrencia?data=${periodo}
			${this.doencas ? `&doencas=${this.doencas}` : ""}`;
        let infowindow = new google.maps.InfoWindow();
        let latLng = new google.maps.LatLng(
          position.coords.latitude,
          position.coords.longitude
        );
        let mapOptions = {
          center: latLng,
          zoom: 16,
          zoomControl: false,
          streetViewControl: false,
          mapTypeControl: false,
          disableDefaultUI: true,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        };

        let mapasintomas = new google.maps.Map(
          this.mapElement.nativeElement,
          mapOptions
        );

        //JSON OCORRENCIAS
        this.http
          .get(json)
          .map(res => res.json())
          .subscribe(data => {
            if (data.locais) {
              let markers = [];
              Object.keys(data.locais).map(key => {
                let ocorrencia = data.locais[key];

                if (ocorrencia.coor === null) {
                  return;
                }

                let coord = ocorrencia.coor.split(",");
                let latLng = new google.maps.LatLng(coord[0], coord[1]);
                let details = "<strong>Sintomas:</strong><br>";

                ocorrencia.sintoma.map(value => {
                  details += `${value}<br>`;
                });

                if (ocorrencia.doenca) {
                  details +=
                    "<br><strong>Doença diagnosticada:</strong><br>" +
                    ocorrencia.doenca;
                }

                let marker = new google.maps.Marker({
                  position: latLng,
                  icon: "assets/img/icon.png",
                  title: details
                });

                marker.setMap(mapasintomas);

                marker.addListener("click", function() {
                  if (infowindow) {
                    infowindow.close();
                  }
                  infowindow.setContent(details);
                  infowindow.open(mapasintomas, marker);
                });

                markers.push(marker);
              });

              //Agrupa ocorrencias
              let clusterStyles = [
                {
                  url: "assets/img/grupo.png",
                  height: 100,
                  width: 70,
                  textColor: "#1566a5",
                  textSize: "40",
                  anchor: [10, 0]
                },
                {
                  url: "assets/img/grupo.png",
                  height: 100,
                  width: 70,
                  textColor: "#1566a5",
                  textSize: "40",
                  anchor: [10, 0]
                },
                {
                  url: "assets/img/grupo.png",
                  height: 100,
                  width: 70,
                  textColor: "#1566a5",
                  textSize: "40",
                  anchor: [10, 0]
                },
                {
                  url: "assets/img/grupo.png",
                  height: 100,
                  width: 70,
                  textColor: "#1566a5",
                  textSize: "40",
                  anchor: [10, 0]
                },
                {
                  url: "assets/img/grupo.png",
                  height: 100,
                  width: 70,
                  textColor: "#1566a5",
                  textSize: "40",
                  anchor: [10, 0]
                }
              ];

              var markerCluster = new MarkerClusterer(mapasintomas, markers, {
                maxZoom: 16,
                styles: clusterStyles,
                zoomOnClick: false
              });

              google.maps.event.addListener(
                markerCluster,
                "clusterclick",
                function(cluster) {
                  // Convert lat/long from cluster object to a usable MVCObject
                  var info = new google.maps.MVCObject();
                  info.set("position", cluster.center_);

                  var markers = cluster.getMarkers();

                  var sintomas = [];
                  var doencas = [];
                  var sintomasTotal = [];
                  var doencasTotal = [];

                  //Get all the titles
                  for (var i = 0; i < markers.length; i++) {
                    var conteudo = markers[i].getTitle();
                    var arr = conteudo
                      .replace(/(<([^>]+)>)/gi, "")
                      .split(/(?=[A-Z])/);
                    var indexDoencaLabel = arr.indexOf("Doença diagnosticada:");

                    if (indexDoencaLabel !== -1) {
                      doencas.push(arr[arr.length - 1]);
                      arr.splice(-2);
                    }

                    arr.map((value, index) => {
                      if (index > 0) {
                        //Nao pegar label "Sintomas:"
                        sintomas.push(value);
                      }
                    });
                  }

                  sintomas.sort();

                  getTotal(sintomas, sintomasTotal);

                  function getTotal(array, novoArray) {
                    var current = null;
                    var cnt = 0;

                    array.map((value, index) => {
                      if (array[index] != current) {
                        if (cnt > 0) {
                          novoArray.push({ nome: current, quantidade: cnt });
                        }
                        current = array[index];
                        cnt = 1;
                      } else {
                        cnt++;
                      }
                    });

                    if (cnt > 0) {
                      novoArray.push({ nome: current, quantidade: cnt });
                    }
                  }

                  function ordernaPorNome(a, b) {
                    if (a.quantidade > b.quantidade) return -1;
                    if (a.quantidade < b.quantidade) return 1;
                    return 0;
                  }

                  sintomasTotal.sort(ordernaPorNome);

                  var texto = "<strong>Sintomas:</strong><br>";

                  sintomasTotal.map((value, index) => {
                    if (index < 5) {
                      texto += `${value.nome}: ${value.quantidade}<br>`;
                    }
                  });

                  if (doencas.length > 0) {
                    getTotal(doencas, doencasTotal);

                    doencasTotal.sort(ordernaPorNome);

                    texto += "<br><strong>Doença diagnosticada:</strong><br>";

                    doencasTotal.map((value, index) => {
                      if (index < 3) {
                        texto += `${value.nome}: ${value.quantidade}<br>`;
                      }
                    });
                  }

                  infowindow.close();
                  infowindow.setContent(texto);
                  infowindow.open(mapasintomas, info);
                }
              );
            }
          });
      },
      err => {
        this.semGPS();
      }
    );

    this.loading.dismiss();
  }

  atualizaMapa() {
    this.navCtrl.setRoot(VerMapaPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/vermapa/vermapa.ts